import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import OutlinedInput from '@mui/material/OutlinedInput'

const CompetitionSelectWinners = forwardRef(
  ({ setOneProtocol, defaultvar = [] }, ref) => {
    const [winners, setWinners] = useState(defaultvar || [])
    const [error, setError] = useState('') // Состояние для ошибки

    const ITEM_HEIGHT = 48
    const ITEM_PADDING_TOP = 8

    const currencies_winners = [
      {
        value: 'По общему весу',
        label: 'По общему весу',
      },
      {
        value: 'По количеству рыб',
        label: 'По количеству рыб',
      },
      {
        value: 'По 1 самой крыпной рыбе',
        label: 'По 1 самой крыпной рыбе',
      },
      {
        value: 'По 3 самым крыпным рыбам',
        label: 'По 3 самым крыпным рыбам',
      },
      {
        value: 'По 5 самым крыпным рыбам',
        label: 'По 5 самым крыпным рыбам',
      },
      {
        value: 'По 10 самым крыпным рыбам',
        label: 'По 10 самым крыпным рыбам',
      },
    ]

    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }

    useEffect(() => {
      if (winners.length > 1) setOneProtocol(false)
      else setOneProtocol(true)
    }, [winners, setOneProtocol])

    const handleChangeWinners = (event) => {
      const {
        target: { value },
      } = event
      setWinners(typeof value === 'string' ? value.split(',') : value)
      setError('')
    }

    const val = () => {
      return winners
    }

    // Метод валидации
    const validate = () => {
      if (winners.length === 0) {
        setError(
          'Необходимо выбрать хотя бы один способ определения победителей'
        )
        return false
      }
      setError('') // Очищаем ошибку, если валидация прошла успешно
      return true
    }

    // Экспортируем метод validate через ref
    useImperativeHandle(ref, () => ({
      validate,
      val,
    }))

    return (
      <FormControl variant="filled" fullWidth margin="none" error={!!error}>
        <InputLabel id="select_winners">Определение победителей</InputLabel>
        <Select
          labelId="select_winners-label"
          id="select_winners_checkbox"
          multiple
          value={winners}
          onChange={handleChangeWinners}
          input={<OutlinedInput label="Определение победителей" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {currencies_winners.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              <Checkbox checked={winners.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
        {/* {error && <FormHelperText error>{error}</FormHelperText>} */}
        <FormHelperText>Можно выбрать несколько</FormHelperText>
      </FormControl>
    )
  }
)

export default CompetitionSelectWinners
